import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UsuarioService } from '../../services/usuario.service';
import { take } from 'rxjs/operators';
import { NgxSpinnerService } from "ngx-spinner";
import { ProdutoConsultaElement } from 'src/app/interfaces/produtos.consulta';
import { LogEstoqueProdutos, ProdutoEstoqueConsulta, ProdutoEstoqueElement } from 'src/app/interfaces/produtos.estoque';
import { ExcelService } from 'src/app/services/excel.service';
import { AngularFireDatabase } from "@angular/fire/database";
import { Loja } from 'src/app/interfaces/manutencao.sistema';
import * as XLSX from 'xlsx';
import * as firebase from 'firebase'; //Timestamp (firebase.default.database.ServerValue.TIMESTAMP)

@Component({
    selector: 'app-gerenciar-estoque',
    templateUrl: './gerenciar-estoque.component.html',
    styleUrls: ['./gerenciar-estoque.component.scss', '../../styles/estilo.padrao.scss']
})
export class GerenciarEstoqueComponent implements OnInit {

    uid: string;
    arrayIDPedidos = [];
    sIDPedidos = '';
    labelArquivo: string = 'Selecionar arquivo';
    StatusServidor: string = '';

    ProdutosEstoque: ProdutoEstoqueElement[];

    Erros: string = '';

    constructor(
        private router: Router,
        private toastr: ToastrService,
        private usuarioService: UsuarioService,
        private spinner: NgxSpinnerService,
        private excelService: ExcelService,
        private db: AngularFireDatabase,
    ) {
        this.uid = localStorage.getItem('uid');
    }

    ngOnInit(): void {
        this.spinner.show('default');
        this.usuarioService.getSistema().pipe(take(1)).subscribe(snap => {
            if (snap) {
                const dados: Loja = snap.payload.val() as Loja;
                if (dados.Status)
                    this.StatusServidor = `Em manutenção - Previsão de retorno: ${dados.PrevisaoRetorno}`;
                else
                    this.StatusServidor = "Atenção, o servidor não está em manutenção!!!";
            }
            this.spinner.hide('default');
        });
    }

    async exportarModeloExcel() {
        this.spinner.show('default');

        await new Promise(resolve => {
            this.ProdutosEstoque = [];

            this.usuarioService.getProdutos().pipe(take(1)).subscribe(snap => {
                if (snap.length > 0) {
                    let dados: ProdutoConsultaElement;
                    let auxProdutosSource: ProdutoEstoqueElement[] = [];

                    snap.forEach((item, index) => {
                        dados = item.payload.val() as ProdutoConsultaElement;
                        if (dados.Status) {
                            auxProdutosSource.push({
                                ID: item.key,
                                QuantidadeEstoque: 0,
                                Nome: dados.Nome
                            });
                        }
                    });
                    this.ProdutosEstoque = auxProdutosSource;
                }

                resolve(null);
            });
        });

        this.usuarioService.getEstoqueProdutos().pipe(take(1)).subscribe(snap => {
            if (snap.length > 0) {
                let index: number;
                let dados: ProdutoEstoqueConsulta;

                snap.forEach((item) => {
                    dados = item.payload.val() as ProdutoEstoqueConsulta;
                    if (dados.QuantidadeEstoque) {
                        index = this.ProdutosEstoque.findIndex(p => p.ID == item.key);
                        if (index !== -1)
                            this.ProdutosEstoque[index].QuantidadeEstoque = dados.QuantidadeEstoque;
                    }
                });
            }
            this.spinner.hide('default');
            console.log('this.ProdutosEstoque', this.ProdutosEstoque);

            this.ProdutosEstoque = this.ProdutosEstoque.sort((a, b) => a.Nome.localeCompare(b.Nome));

            this.excelService.exportAsExcelFile(this.ProdutosEstoque, `Modelo_importacao_estoque_${this.usuarioService.tratarData(new Date().getTime())}`);
        });
    }

    gerenciarEstoque(event: any) {
        this.spinner.show('default');
        /* wire up file reader */
        // @ts-ignore
        const target: DataTransfer = <DataTransfer>(event.target);
        if (target.files.length !== 1) {
            this.spinner.show('hide');
            this.toastr.error("Não é possível selecionar mais de um arquivo!", 'Erro');
        }
        this.labelArquivo = target.files[0].name;
        const reader: FileReader = new FileReader();
        reader.readAsBinaryString(target.files[0]);
        reader.onload = (e: any) => {
            /* create workbook */
            const binarystr: string = e.target.result;
            const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: 'binary' });

            /* selected the first sheet */
            const wsname: string = wb.SheetNames[0];
            const ws: XLSX.WorkSheet = wb.Sheets[wsname];

            /* save data */
            this.atualizarEstoques(XLSX.utils.sheet_to_json(ws));
            event.target.value = null;
        };
    }

    async atualizarEstoques(produtos: ProdutoEstoqueElement[]) {

        this.toastr.info('Atualizando estoques...', 'Status', { progressBar: true, positionClass: 'toast-top-center' });
        this.Erros = '';

        await Promise.all(produtos.map(async (produto) => {
            this.toastr.clear();
            this.toastr.info(`Atualizando: ${produto.Nome} - Quantidade: ${produto.QuantidadeEstoque}`, 'Status', { progressBar: true, positionClass: 'toast-top-center' });

            await this.db.object(`Clientes/${this.uid}/EstoqueProdutos/${produto.ID}/QuantidadeEstoque`).query.ref.transaction(valor => {

                valor = Number(produto.QuantidadeEstoque);
                return valor;

            }).then(async () => {

                const map: LogEstoqueProdutos = {
                    Tipo: 'Ajuste manual',
                    Pedido: 0,
                    AcrescimoDecrescimoControleGerenciar: produto.QuantidadeEstoque,
                    QuantidadeEstoqueAposOperacao: produto.QuantidadeEstoque,
                    Timestamp: firebase.default.database.ServerValue.TIMESTAMP,
                    Falha: ''
                }

                await this.usuarioService.setLogEstoqueProdutos(map, produto.ID);
                return true;
            }).catch(async error => {
                const map: LogEstoqueProdutos = {
                    Tipo: 'Falha alteração manual',
                    Pedido: 0,
                    AcrescimoDecrescimoControleGerenciar: produto.QuantidadeEstoque,
                    QuantidadeEstoqueAposOperacao: produto.QuantidadeEstoque,
                    Timestamp: firebase.default.database.ServerValue.TIMESTAMP,
                    Falha: error
                }

                await this.usuarioService.setLogEstoqueProdutos(map, produto.ID);

                this.Erros += `${produto.ID} - ${produto.QuantidadeEstoque} - Error: ${error}\n\n`
            });
        })).then(() => {
            this.toastr.clear();
            if (this.Erros === '')
                this.toastr.success('Estoque atualizado com sucesso!', 'Status', { progressBar: true, positionClass: 'toast-top-center', });
            else
                this.toastr.error('Houve uma ou mais falhas ao atualizar o estoque!', 'Status', { progressBar: true, positionClass: 'toast-top-center', });

            this.spinner.hide('default');
        });
    }

    voltar() {
        this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
            this.router.navigate(["/pages/gerenciar-estoque"]));
    }

}
